import {adGroupApi} from 'common/api/entitiesApi'
import {OwnedEntitySelector} from 'common/components/reloadable/OwnedEntitySelector'
import React from 'react'

export interface Props {
    advertiserId?: number
    value?: number
    onChange?: (value?: number | number[]) => void
    style?: React.CSSProperties
    disabled?: boolean
    placeholder?: string
    multiple?: boolean
}

export const AdGroupSelector = ({advertiserId, value, onChange, style, disabled, placeholder, multiple}: Props) => {

    function loadEntity(id: number) {
        return adGroupApi.adGroup(id)
    }

    function searchEntities(search: string, size: number, page: number, advId?:number) {
        return adGroupApi.adGroupList(
            'name', 'asc', search,
            undefined, undefined, advId, undefined, undefined, undefined,
            {query: {size, page}}
        )
    }

    return <OwnedEntitySelector
        ownerId={advertiserId}
        value={value}
        onChange={onChange}
        loadEntity={loadEntity}
        searchEntities={searchEntities}
        placeholder={placeholder}
        disabled={disabled}
        style={style}
        errorText="Can't load AdGroups"
        multiple={multiple}
    />
}
